module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("LDL4z"))).then(() => parcelRequire('1iHdE'));